import React from 'react';
export default class Footer extends React.Component {
  render() {
    return (
      <div>
        <footer className="m-grid__item m-footer ">
          <div className="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
            <div className="m-footer__wrapper">
              <div className="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
                <div className="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
                  <span className="m-footer__copyright">
                    2018 &copy;
                          <a href="https://uffride.com" target="_blank" className="m-link">
                      UffRide Inc.
                          </a>
                    All Rights Reserved.
                      </span>
                </div>
                <div className="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
                  <ul className="m-footer__nav m-nav m-nav--inline m--pull-right">
                    <li className="m-nav__item">
                      <a className="btn m-nav__link">
                        <span className="m-nav__link-text">About</span>
                      </a>
                    </li>
                    <li className="m-nav__item">
                      <a className="btn m-nav__link">
                        <span className="m-nav__link-text">Privacy</span>
                      </a>
                    </li>
                    <li className="m-nav__item">
                      <a className="btn m-nav__link">
                        <span className="m-nav__link-text">T&C</span>
                      </a>
                    </li>

                    <li className="m-nav__item m-nav__item--last">
                      <a className="btn m-nav__link" data-toggle="m-tooltip" title="Support Center" data-placement="left">
                        <i className="m-nav__link-icon flaticon-info m--icon-font-size-lg3"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className="m-scroll-top m-scroll-top--skin-top" data-toggle="m-scroll-top" data-scroll-offset="500" data-scroll-speed="300">
          <i className="la la-arrow-up"></i>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/include/Footer.js